import {createRouter, createWebHashHistory} from 'vue-router'
import {aryRouter} from './router_page.js'
import FloatLayerCom from '../components/zmr-float-layer.vue'
import {createApp} from 'vue'
import {getCache, setCache, clearAll, getExpiresCache} from '../common/js/cache.js'
import {isNotEmpty} from "../common/js/comjs.js";
import store from '@/store/index'
/**
 * 加载h5浏览器提示
 * @type {App<Element>}
 */
const floatLayerApp = createApp(FloatLayerCom);
const mountEl = document.createElement(`div`);
mountEl.id = "floatLayerApp";
document.body.appendChild(mountEl);
floatLayerApp.mount(`#floatLayerApp`)

/**
 * 处理页面加载进度条
 * @param status
 * @param to
 */
function changeFloat(status, to) {
    if (to.navType !== `back`) {
        if (isNotEmpty(floatLayerApp._instance) && isNotEmpty(floatLayerApp._instance.setupState)) {
            floatLayerApp._instance.setupState.toggleFloat(status);
        }
    }
}

/**
 * 创建路由
 * @type {Router}
 */
const router = createRouter({
    history: createWebHashHistory(),
    routes: aryRouter,
})
/**
 * 路由开始加载
 */
router.beforeEach((to, form, next) => {
    //检验路由地址是否配置
    /*if (!isNotEmpty(to.meta) || !isNotEmpty(to.meta.title)) {
        next('/401');
        return;
    }*/
    /*//校验系统是否一直在线
    if (!checkSystemIsOnLine(to.path)) {
        //next('/login');
        //return;
    }*/
    //校验用户是否已经登录
    if (to.meta.loginAuth) {
        let tokenType = checkUserLogin();
        if (tokenType === 'empty') {
            next('/login');
            return;
        }
        if (tokenType === 'expires') {
            setCache('lastRouterPath', to.fullPath, 3600000);
            next('/login');
            return;
        }
    }
    //校验是否拥有访问的权限
    if (to.meta.visitAuth) {
        if (!checkUserAuth(to.path)) {
            next('/noauth');
            return;
        }
    }
    changeFloat("load", to);
    next();
})
/**
 * 路由加载成功
 */
router.afterEach((to) => {
    changeFloat("success", to);
    if (isNotEmpty(to.meta) && isNotEmpty(to.meta.title)) {
        document.title = store.state.systemName;
    }
})
/**
 * 路由加载报错
 */
router.onError((error) => {
    //系统重新打包后访问静态文件-加载报错：重新加载系统。
    console.log(error)
    /*if (error.indexOf('Loading') >= 0) {
        ElMessageBox({
            title: '系统提示',
            message: '系统已经更新，请重新加载系统！',
            type: 'error',
            confirmButtonText: '确定',
            buttonSize: 'small',
        }).then(() => {
            location.reload();
        }).catch(() => {
        });
    }*/
})

/**
 * 校验用户是否存在访问权限
 * @param path
 * @returns {boolean}
 */
function checkUserAuth(path) {
    let aryAuth = getCache('userAuth');
    if (isNotEmpty(aryAuth) && aryAuth.indexOf(path) > 0) {
        return true;
    } else {
        return false;
    }
}

/**
 * 校验用户是否已经登录
 * @returns {boolean}
 */
function checkUserLogin() {
    let aryToken = getExpiresCache('loginToken');
    if (isNotEmpty(aryToken.val)) {
        //更新登录时间-保持1小时有效期
        setCache('loginToken', aryToken.val);
        return aryToken.type;
    } else {
        clearAll();
        return aryToken.type;
    }
}

/**
 * 校验系统是否一直在线
 */
/*function checkSystemIsOnLine(path) {
    //排除不需要校验的路由地址
    let noCheckPath = ['/login'];
    if (noCheckPath.length > 0 && noCheckPath.indexOf(path) >= 0) {
        return true;
    }
    //校验是否一直在页面中
    let oldSysTime = getCache('systemTime');
    let newSysTime = Math.floor(new Date().getTime() / 1000);
    if (!isNotEmpty(oldSysTime) || (newSysTime - oldSysTime) > 2) {
        clearAll();
        return false;
    }
    return true;
}*/

export default router;
